import React from 'react';
import { navigate } from 'gatsby';

const BriefIndexPage = () => {
  if (typeof window !== 'undefined') {
    navigate(`/hello${location.search}`)
  }
  return <></>;
};

export default BriefIndexPage;

